import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables. Please check your .env file.');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export interface Transcription {
  id: string;
  user_id: string;
  content: string;
  created_at: string;
}

export async function saveTranscription(content: string): Promise<void> {
  const { error } = await supabase
    .from('transcriptions')
    .insert([
      {
        content,
        user_id: supabase.auth.getUser().then(({ data }) => data.user?.id),
      },
    ]);

  if (error) throw error;
}